import { SET_ESIG_NEXT_STEP, SET_PERSONAL_PORTFOLIO_FLOW_DATA } from 'stash/actions';

const eSig = (state = {}, action) => {
	switch (action.type) {
		case SET_ESIG_NEXT_STEP: {
			return {
				...state,
				eSigNextStep: action.value, // value already has suffix _ACCOUNT
			};
		}

		case SET_PERSONAL_PORTFOLIO_FLOW_DATA: {
			return {
				...state,
				personalPortfolioFlowData: action.value,
			};
		}
		default:
			return state;
	}
};

export default eSig;
